export var EAddedAdsType = /*#__PURE__*/function (EAddedAdsType) {
  EAddedAdsType["No"] = "no";
  EAddedAdsType["Owner"] = "owner";
  EAddedAdsType["Realtor"] = "realtor";
  EAddedAdsType["Employee"] = "employee";
  EAddedAdsType["Agency"] = "agency";
  return EAddedAdsType;
}({});